import {useState} from "react";
import {withTranslation} from "react-i18next";
import {
ArrowRightOutlined} from '@ant-design/icons';
import "../cervo.scss";
import {Button} from 'antd';

import localOrSessionStore from "_helpers/localOrSessionStore";
import variables from "_constants/variables";
import { MdPlayCircleFilled } from "react-icons/md";
// import {MdPlayCircleFilled} from "react-icons";

function StepCervoVideo(props) {
    const storage = localOrSessionStore({ key: variables.REMEMBER });
    const user = JSON.parse(storage.getItem(variables.USER));
    const [video, setVideo] = useState(false)
    const {t} =props;

    return (

      <div className={"containerStartCervoTwo wrapper history"}>
          <div className={"video-overlay"}></div>
          <div className={"container-history container-history--video boxed"}>
              {!video &&
                <div className={"history-play-video"}>
                    <MdPlayCircleFilled onClick={() => setVideo(true)}/>
                    <p onClick={() => setVideo(true)}>{t("ceiba.vervideo")}</p>
                </div>
              }
              {video &&
                <div className={"history-view-video"}>
                    <iframe id="kaltura_player"
                            className={"history-view-video-iframe"}
                            src="https://cdnapisec.kaltura.com/p/2206521/sp/220652100/embedIframeJs/uiconf_id/42503771/partner_id/2206521?iframeembed=true&playerId=kaltura_player&entry_id=1_3rn035fg&flashvars[streamerType]=auto&amp;flashvars[autoPlay]=true&amp;flashvars[localizationCode]=es&amp;flashvars[leadWithHTML5]=true&amp;flashvars[sideBarContainer.plugin]=true&amp;flashvars[sideBarContainer.position]=left&amp;flashvars[sideBarContainer.clickToClose]=true&amp;flashvars[chapters.plugin]=true&amp;flashvars[chapters.layout]=vertical&amp;flashvars[chapters.thumbnailRotator]=false&amp;flashvars[streamSelector.plugin]=true&amp;flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&amp;flashvars[dualScreen.plugin]=true&amp;flashvars[hotspots.plugin]=1&amp;flashvars[Kaltura.addCrossoriginToIframe]=true&amp;&wid=1_jwwh6n8k"
                            allowFullScreen webkitallowfullscreen mozAllowFullScreen
                            allow="autoplay; fullscreen *; encrypted-media *"
                            sandbox="allow-downloads allow-forms allow-same-origin allow-scripts allow-top-navigation allow-pointer-lock allow-popups allow-modals allow-orientation-lock allow-popups-to-escape-sandbox allow-presentation allow-top-navigation-by-user-activation"
                            frameBorder="0" title="Las grutas de Dokia">
                    </iframe>
                </div>
              }
              <div className={"container-dialogue"}>
                  <div className={"dialogue-buttons"}>
                      <div className="left margin-right-auto">
                          <Button
                            type={"link"}
                            onClick={() => props.goTo(2)}
                            style={{backgroundColor: "white", paddingLeft: 15}}
                          >
                              {t("atras")}
                          </Button>
                      </div>
                      <div className="right">
                          <Button icon={<ArrowRightOutlined />}
                                  onClick={() => props.goTo(4)}
                                  type={"primary"}
                                  className="primaryButton"
                          >
                              {t("next")}
                          </Button>
                      </div>
                  </div>
              </div>
          </div>
      </div>

    )
}

export default withTranslation()(StepCervoVideo);
